import axios from 'axios';
import {
  LandlordRegistrationForm,
  LandlordUpdate,
} from '../models/landlordModel';

const loadAbort = () => {
  return new AbortController();
};

export const getLandlordEndpoint = (landlordId: string = '', token: string) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: 'get',
        url: `${urlService}/user/v1/admin/landlord/${landlordId}`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};

export const getLandlordsEndpoint = (query: string = '', token: string) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: 'get',
        url: `${urlService}/user/v1/admin/landlord${query}`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};

export const createLandlordEndpoint = (
  form: LandlordRegistrationForm,
  token: string,
) => {
  const controller = loadAbort();
  return {
    call: async (urlService: string) => {
      console.log('Petición createLandlordEndpoint:', form);
      try {
        const response = await axios({
          method: 'post',
          // url: `${urlService}/user/v1/admin/landlord/create`,
          url: `${urlService}/user/v1/admin/customer`,
          data: JSON.stringify(form),
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        });
        console.log('Respuesta createLandlordEndpoint:', response);
        return response;
      } catch (error) {
        console.error('Error en createLandlordEndpoint:', error);
        if (error) {
          console.error('Error response:', error);
        }
        throw error;
      }
    },
    controller,
  };
};

export const updateLandlordEndpoint = (
  landlordId: string,
  payload: LandlordUpdate,
  token: string,
) => {
  const controller = loadAbort();
  return {
    call: async (urlService: string) => {
      //console.log('Petición:', payload);
      try {
        const response = await axios({
          method: 'put',
          url: `${urlService}/user/v1/admin/landlord/${landlordId}`,
          data: JSON.stringify(payload),
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        });
        //console.log('Respuesta:', response);
        return response;
      } catch (error) {
        //console.error('Error en updateLandlordEndpoint:', error);
        if (error) {
          //console.error('Error response:', error);
        }
        throw error;
      }
    },
    controller,
  };
};

export const updateLandlordBankInfoEndpoint = (
  landlordId: string,
  payload: any,
  token: string,
) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: 'put',
        url: `${urlService}/user/v1/admin/landlord/${landlordId}/bank-info`,
        data: JSON.stringify(payload),
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};

export const getAreaCodesEndpoint = (token: string) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: 'get',
        url: `${urlService}/user/v1/country`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};
